import script from "./assets-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./assets-modal.vue?vue&type=script&setup=true&lang=js"

import "./assets-modal.vue?vue&type=style&index=0&id=7a180619&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a180619"]])

export default __exports__